import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../translations/translations';

const BenefitsSection = () => {
  const { language } = useLanguage();
  const benefitCards = [
    {
      roleKey: "benefitsSection.benefitForManagement",
      type: "management",
      icon: "bi-building",
      benefitsKey: "benefitsSection.managementBenefits"
    },
    {
      roleKey: "benefitsSection.benefitForTeachers",
      type: "teachers",
      icon: "bi-person-workspace",
      benefitsKey: "benefitsSection.teacherBenefits"
    },
    {
      roleKey: "benefitsSection.benefitForParents",
      type: "parents",
      icon: "bi-house-heart",
      benefitsKey: "benefitsSection.parentBenefits"
    }
  ];

  return (
    <section className="section-padding benefits-section" id="benefits">
      <svg className="section-bg left" width="250" height="250" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="orangeGradientLeftBenefits" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffbda1" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#ff6b35" stopOpacity="0.8" />
          </linearGradient>
        </defs>
        <path d="M100,30 Q140,10 180,40 Q200,80 180,120 Q160,160 120,180 Q80,200 40,180 Q0,160 10,120 Q20,80 40,40 Q60,10 100,30 Z" fill="url(#orangeGradientLeftBenefits)" />
      </svg>
      <svg className="section-bg right" width="250" height="250" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="orangeGradientRightBenefits" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffbda1" stopOpacity="0.8" />
            <stop offset="100%" stopColor="#ff6b35" stopOpacity="0.8" />
          </linearGradient>
        </defs>
        <path d="M100,30 Q140,10 180,40 Q200,80 180,120 Q160,160 120,180 Q80,200 40,180 Q0,160 10,120 Q20,80 40,40 Q60,10 100,30 Z" fill="url(#orangeGradientRightBenefits)" />
      </svg>
      <div className="container">
        <div className="section-title" data-aos="fade-up">
          <h2>{getTranslation(language, 'benefitsSection.benefitsTitle')}</h2>
          <p>
            {getTranslation(language, 'benefitsSection.benefitsSubtitle')}
          </p>
        </div>
        
        <div className="row g-4">
          {benefitCards.map((card, index) => {
            const benefits = getTranslation(language, card.benefitsKey);
            return (
              <div 
                key={index} 
                className="col-lg-4"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className={`benefit-card ${card.type}`}>
                  <div className="benefit-icon">
                    <i className={`bi ${card.icon}`}></i>
                  </div>
                  <h4>{getTranslation(language, card.roleKey)}</h4>
                  <ul>
                    {Array.isArray(benefits) && benefits.map((benefit, idx) => (
                      <li key={idx}>
                        <i className="bi bi-check2"></i>
                        {benefit}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
